const BUNDLE = "/bundle";

export const GET_BUNDLES = `${BUNDLE}/getAllActiveBundles`;

export const GET_BUNDLE_DETAILS = `${BUNDLE}/getBundle/:bundleId`;
